import type { ServicePageCalloutContent, ServicePageSectionContent } from '../../data'
import { Link } from 'react-router'
import { ServiceList } from './ServiceList'

interface ServiceContentProps {
  sections: readonly ServicePageSectionContent[]
  callout?: ServicePageCalloutContent
}

export function ServiceContent({ sections, callout }: ServiceContentProps) {
  return (
    <div className="service-content">
      {sections.map((section, index) => (
        <section className="service-content__section" key={section.heading ?? `section-${index + 1}`}>
          {section.heading ? <h2>{section.heading}</h2> : null}
          {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {section.list ? <ServiceList list={section.list} /> : null}
        </section>
      ))}

      {callout ? (
        <aside className="service-callout">
          <h2>{callout.title}</h2>
          <p>{callout.body}</p>
          {callout.linkHref && callout.linkLabel ? (
            <Link to={callout.linkHref}>{callout.linkLabel} →</Link>
          ) : null}
        </aside>
      ) : null}
    </div>
  )
}
